






















import { combineArtistTitle } from '@/helpers/track'
import { IAudioFeatureTrack } from '@/views/Private/Features/_Hidden/PlaylistSorter.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    GlobalWaveform: require('@/components/GlobalWaveform').default
  }
})
export default class PlaylistSorterItem extends Vue {
  @Prop()
  data: IAudioFeatureTrack

  get link(): string {
    return `spotify://${this.data.url}`
  }

  get name(): string {
    return combineArtistTitle(this.data.artist, this.data.title)
  }

  getColor(n: number): string {
    if (n < 0.33) return 'has-text-warning'
    else if (n < 0.66) return 'has-text-info'
    else return 'has-text-success'
  }
}
